module.exports = __webpack_public_path__ + "static/media/1443603138.4c704977.jpg";